import LegalPage from "../components/legal-page";

function Privacy() {
  return (
    <LegalPage
      title="Privacy Policy"
      description="How AimanRe.my handles data, cookies, and advertising through Google AdSense."
      path="/privacy"
      updated="18 October 2026"
    >
      <p>
        This site is a personal notebook run by Aiman. It has no accounts, no comment
        forms, and no store. The only thing it asks from you is a little attention, and
        even that is optional.
      </p>

      <h2>What is collected</h2>
      <p>
        Like most websites, the hosting provider sees basic technical information when a
        page is requested: your IP address, browser type, the page you visited, and the
        time of the request. This is used to deliver the site, keep it secure, and
        understand traffic in aggregate. It is not used to build a dossier on you. I am
        not that organised.
      </p>
      <p>
        This site may use privacy-friendly analytics to count visits and page views. It
        does not build a personal profile of you, and I do not sell visitor data.
      </p>
      <p>
        Your theme choice (light, dark, or system) is stored in your browser&apos;s local
        storage. It stays on your device and is not sent to me. I do not know whether you
        prefer dark mode, but I respect it.
      </p>

      <h2>Cookies and advertising</h2>
      <p>
        This site is supported by advertising through Google AdSense. Third-party
        vendors, including Google, use cookies to serve ads based on your prior visits to
        this website or other websites. Google&apos;s use of advertising cookies enables
        Google and its partners to serve ads to you based on your visits to this site
        and/or other sites on the internet.
      </p>
      <p>
        The ads pay for the domain and the occasional iced coffee. Google chooses them,
        not me, so please do not blame me if you get an ad for a mattress.
      </p>
      <p>
        You can opt out of personalised advertising by visiting{" "}
        <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
          Google Ads Settings
        </a>
        . You can also opt out of some third-party vendors&apos; use of cookies for
        personalised advertising at{" "}
        <a href="https://www.aboutads.info" target="_blank" rel="noopener noreferrer">
          aboutads.info
        </a>
        . Blocking cookies does not stop ads from appearing, but it may make them less
        relevant to you.
      </p>

      <h2>Third-party links</h2>
      <p>
        Articles may link to other websites. The internet is a neighbourhood, and I do
        not control the other houses. Those sites have their own privacy practices, and
        this policy does not cover them. It is worth reading their privacy pages before
        sharing personal information.
      </p>

      <h2>Children</h2>
      <p>
        This site is not directed at children under 13, and I do not knowingly collect
        personal information from them. If a child is reading this, hello — please go ask
        an adult for a snack.
      </p>

      <h2>Your choices</h2>
      <p>
        You can clear or block cookies in your browser settings. You can use the ad
        settings links above to manage personalised advertising. Because this site does
        not have accounts, there is no profile to delete. Small mercies.
      </p>

      <h2>Changes</h2>
      <p>
        If this policy changes, the new version will appear on this page with an updated
        date, like a receipt. Continued use of the site after a change means you accept
        the updated policy.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about privacy can be sent to me on{" "}
        <a
          href="https://www.threads.com/@muhdaimanrs"
          target="_blank"
          rel="noopener noreferrer"
        >
          Threads
        </a>
        ,{" "}
        <a href="https://x.com/muhdaimanrs" target="_blank" rel="noopener noreferrer">
          X
        </a>
        , or through{" "}
        <a href="https://github.com/muhdaimanrs" target="_blank" rel="noopener noreferrer">
          GitHub
        </a>
        . I read everything, though I may reply at the speed of a weekend.
      </p>
    </LegalPage>
  );
}

export default Privacy;
